import React from 'react'

interface DocumentCardResultCountLabelProps {
  displayCount: number
  hasActiveFilters: boolean
  pageEnd: number
  pageStart: number
  resultCount: number
  totalCount: number
}

export function DocumentCardResultCountLabel({
  displayCount,
  hasActiveFilters,
  pageEnd,
  pageStart,
  resultCount,
  totalCount,
}: DocumentCardResultCountLabelProps): React.ReactElement {
  return (
    <>
      Showing {resultCount > 0 ? pageStart + 1 : 0}-{pageEnd} of{' '}
      {displayCount.toLocaleString()} result
      {displayCount !== 1 ? 's' : ''}
      {hasActiveFilters && totalCount !== displayCount && (
        <> (filtered from {totalCount.toLocaleString()})</>
      )}
    </>
  )
}
